//@flow
import * as React from "react";
import styled from "react-emotion";
import { theme, mqMin, AbsOverflow } from "../../styles/theme";
import ScrollNotifier from "../ScrollNotifier";
import MenuWrap from "../MenuWrap";

const Screen = styled.section`
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-wrap: none;
  justify-content: center;
  align-items: center;
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  ${mqMin(theme.desktop)} {
    margin-left: auto;
    margin-right: auto;
    max-width: ${theme.maxWidth3};
  }
`;
const Text = styled.h2`
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.bold};
  font-size: ${theme.h3};
  line-height: ${theme.lineHeight3};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h2};
  }
  ${mqMin(theme.desktop)} {
    font-size: ${theme.super};
  }
`;
const Heading = styled.h3`
  font-size: ${theme.h3};
  font-family: ${theme.heading.fontFamily};
  font-weight: ${theme.heading.normal};
  line-height: ${theme.lineHeight1};
  margin-bottom: ${theme.space1};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h2};
  }
`;

const MobileBlock = styled.div`
  display: block;
  margin-bottom: ${theme.space1};
  ${mqMin(theme.tablet)} {
    display: inline;
  }
`;
const HideMobile = styled.span`
  display: none;
  ${mqMin(theme.tablet)} {
    display: initial;
  }
`;

const DotBreak = () => (
  <MobileBlock>
    <HideMobile> • </HideMobile>
  </MobileBlock>
);

const Contact = ({
  page,
  heading = "We're waiting ever so patiently to meet you!"
}) => {
  return (
    <MenuWrap y={100} open={"CONTACT"}>
      <Screen>
        <div>
          <Heading>{heading}</Heading>
          <Text>
            9 W. Washington St <br />
            Ellicottville, NY 14731<br />
            <a href="mailto:info@pandagoatmedia.com">info@pandagoatmedia.com</a>
            <br />
            <a href="tel:(716)699-9816">(716) 699-9816</a>
          </Text>
        </div>
      </Screen>
    </MenuWrap>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/index.js